import { useState, useEffect, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import TopNavBar from '../components/navigation/TopNavBar'
import RoundedButton from '../components/buttons/RoundedButton'
import RoundedBorderButton from '../components/buttons/RoundedBorderButton'
import SectionHeaderView from '../components/views/SectionHeaderView'
import FormInput from '../components/inputs/FormInput'
import FormInput2 from '../components/inputs/FormInput2'
import DropdownInput from '../components/inputs/DropdownInput'
import DatePickerInput2 from '../components/inputs/DatePickerInput2'
import LoadingModal from '../components/modals/LoadingModal'
import TwoButtonsModal from '../components/modals/TwoButtonsModal'
import * as Constants from '../utils/constants'
import dayjs from 'dayjs'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import arrow from '../assets/arrow.png'
import strings from '../res/strings'
import 'react-toastify/dist/ReactToastify.css'

const ScheduleDetails = () => {
    const { id } = useParams()

    const [services, setServices] = useState(null)
    const [harbors, setHarbors] = useState(null)
    const [equipments, setEquipments] = useState(null)
    const [schedule, setSchedule] = useState(null)
    const [isPastSchedule, setIsPastSchedule] = useState(false)

    const [showCancelScheduleModal, setShowCancelScheduleModal] = useState(false)

    const [boat, setBoat] = useState(false)

    const [docapescaId, setDocapescaId] = useState(null)

    const [initialReading, setInitialReading] = useState('')
    const [finalReading, setFinalReading] = useState('')
    const [boxNumber, setBoxNumber] = useState('')
    const [closingDate, setClosingDate] = useState(null)
    const [closingDateError, setClosingDateError] = useState(null)
    const [closingDateSelected, setClosingDateSelected] = useState(false)

    const [amount, setAmount] = useState('')
    const [unitaryValue, setUnitaryValue] = useState('')
    const [selectedIva, setSelectedIva] = useState(null)

    const [isTravelLiftChecked, setIsTravelLiftChecked] = useState(false)
    const [isAgriculturalTractor, setIsAgriculturalTractor] = useState(false)
    const [isAutomobileCrane5T, setIsAutomobileCrane5T] = useState(false)
    const [isAutomobileCrane10T, setIsAutomobileCrane10T] = useState(false)

    const [isLoading, setIsLoading] = useState(true)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else {
                getScheduleDetails()
                getInterventionTypes()
                getHarbors()
                getEquipments()
                getDocapescaId()
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    // Handle get intervetion types request
    const getInterventionTypes = () => {
        fetch('/api/Schedule/Types', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                setServices(jsonRes)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getIntervetionTypesError)

                    setServices([])
                }, 1000)
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setServices([])
            }, 1000)
        })
    }

    // Handle get harbors
    const getHarbors = () => {
        if(loggedUser.role === Constants.Roles.CLIENT) {
            fetch('/api/Boat/Dropdowns', {
                method:'GET',
                headers: { 
                  'Accept': 'application/json',
                  'Content-Type': 'application/json; charset=UTF-8',
                  'Authorization': 'Bearer ' + loggedUser.jwtToken
                }, 
                mode: 'cors'
            }).then(async response => {
                if (response.status === 200) {
                    const jsonRes = await response.json()
    
                    setHarbors(jsonRes.harbors)
                } else {
                    setTimeout(() => {
                        setIsLoading(false)
                        showErrorToast(strings.getDropdownsError)
        
                        setHarbors([])
                    }, 1000)
                }
        
            }).catch((error) => {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(error)
    
                    setHarbors([])
                }, 1000)
            })
        } else {
            fetch('/api/Backoffice/ListHarbors', {
                method:'GET',
                headers: { 
                  'Accept': 'application/json',
                  'Content-Type': 'application/json; charset=UTF-8',
                  'Authorization': 'Bearer ' + loggedUser.jwtToken
                }, 
                mode: 'cors'
            }).then(async response => {
                if (response.status === 200) {
                    const jsonRes = await response.json()
    
                    setHarbors(jsonRes)
                } else {
                    setTimeout(async () => {
                        setIsLoading(false)
                        
                        showErrorToast(strings.getDropdownsError)
                        setHarbors([])
                    }, 1000) 
                }
    
            }).catch((error) => {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(error)
    
                    setHarbors([])
                }, 1000)   
            })
        }
    }

    // Handle get equipments request
    const getEquipments = () => {
        fetch('/api/Schedule/ListEquipment', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                setEquipments(jsonRes)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getEquipmentsError)

                    setEquipments([])
                }, 1000)
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setEquipments([])
            }, 1000)
        })
    }

    // Handle get boat details
    const getBoatDetails = (boatId) => {
        fetch(`/api/Boat/${boatId}/Details`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()
    
                    setBoat(jsonRes)
                } else {
                    showErrorToast(strings.getBoatDetailsError)
                        
                    setBoat(null)
                }
            }, 1000) 

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setBoat(null)
            }, 1000)  
        })
    }

    // Handle get schedule details
    const getScheduleDetails = () => {
        fetch(`/api/Schedule/${id}/Details`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()
              
                setSchedule(jsonRes)

                const today = new Date()

                let currentDate

                if(jsonRes.endDate) {
                    currentDate = new Date(jsonRes.endDate)
                } else if(jsonRes.startDate) {
                    currentDate = new Date(jsonRes.startDate)
                } else {
                    currentDate = new Date(jsonRes.accessFacilitiesStartDate)
                }

                if(currentDate >= today) {
                    setIsPastSchedule(false)
                } else {
                    setIsPastSchedule(true)
                }

                switch(jsonRes.equipmentId) {
                    case Constants.EQUIPMENTS.travelLift: 
                        setIsTravelLiftChecked(true);
                        break
        
                    case Constants.EQUIPMENTS.agriculturalTractor: 
                        setIsAgriculturalTractor(true);
                        break
        
                    case Constants.EQUIPMENTS.automobileCrane5T: 
                        setIsAutomobileCrane5T(true);
                        break
            
                    case Constants.EQUIPMENTS.automobileCrane10T: 
                        setIsAutomobileCrane10T(true);
                        break
        
                    default: 
                        setIsTravelLiftChecked(false)
                        setIsAgriculturalTractor(false)
                        setIsAutomobileCrane5T(false)
                        setIsAutomobileCrane10T(false)

                }

                getBoatDetails(jsonRes.boatId)
            } else {
                setTimeout(async () => {
                    setIsLoading(false)
                    showErrorToast(strings.getScheduleDetailsError)

                    setSchedule(null)
                }, 1000)      
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setSchedule(null)
            }, 1000) 
        })
    }

    // Handle get Docapesca entity id request
    const getDocapescaId = () => {
        fetch(`/api/Backoffice/GetDocapescaId`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()
    
                    setDocapescaId(jsonRes)
                } else {
                    showErrorToast(strings.getDocapescaIdError)
                    
                    setDocapescaId(null)
                }
            }, 1000)
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setDocapescaId(null)
            }, 1000)
        })
    }

    // Handle reject schedule suggestion
    const rejectSuggestion = () => {
        setIsLoading(true)

        // Reject schedule
        fetch(`/api/Schedule/${id}/Respond?response=false`, {
            method:'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    navigate(-1)
                } else {
                    showErrorToast(strings.rejectScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    // Handle accept schedule suggestion
    const acceptSuggestion = () => {
        setIsLoading(true)

        // Accept schedule
        fetch(`/api/Schedule/${id}/Respond?response=true`, {
            method:'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    navigate(-1)
                } else {
                    showErrorToast(strings.acceptScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    // Handle discard schedule
    const discardSchedule = () => {
        setIsLoading(true)

        // Discard schedule
        fetch(`/api/Schedule/${id}/Delete`, {
            method:'DELETE',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    navigate(-1)
                } else {
                    showErrorToast(strings.discardScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    // Handle reschedule
    const reschedule = () => {
        setIsLoading(true)

        // Delete schedule
        fetch(`/api/Schedule/${id}/Delete`, {
            method:'DELETE',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    navigate('/new-schedule', {
                        state: {
                            service: schedule && schedule.scheduleTypeId,
                            boat: schedule && schedule.boatId,
                            harbor: schedule && schedule.harborId
                        }}
                    )
                } else {
                    showErrorToast(strings.cancelScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })     
    }

    // Show cancel modal
    const onClickCancel = () => {
        setShowCancelScheduleModal(true)
    }

    // Handle cancel reschedule
    const cancelSchedule = () => {
        setShowCancelScheduleModal(false)
        setIsLoading(true)

        // Cancel schedule
        fetch(`/api/Schedule/${id}/Delete`, {
            method:'DELETE',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    navigate(-1)
                } else {
                    showErrorToast(strings.cancelScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    // Handles date formatting
    const formatDate = (timeStamp) => {
        const date = new Date(timeStamp)
        const day = date.getDate()
        const month = Constants.MONTHS[date.getUTCMonth()]
        const year = date.getUTCFullYear()
        return `${day} de ${month} de ${year}`
    }

    // Handle date formatting
    const formatDate2 = (date) => {
        const selectedDate = new Date(date)
        selectedDate.setHours(new Date().getHours())
        return selectedDate.toISOString()
    }

    // Handles date formatting
    const formatDate3 = (timeStamp) => {
        const date = new Date(timeStamp)
        const day = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()
        const hours = date.getHours()
        const minutes = date.getMinutes()
        return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year} ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`
    }

    // Handles time formatting
    const formatTime = (timeStamp) => {
        const date = new Date(timeStamp)
        const hours = date.getHours()
        const minutes = date.getMinutes()
        return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes} h`
    }

    // Handle changes in initial reading input text
    const onChangeInitialReading = (initialReadingText) => {
        setInitialReading(initialReadingText.target.value)
    }

    // Handle changes in final reading input text
    const onChangeFinalReading = (finalReadingText) => {
        setFinalReading(finalReadingText.target.value)
    }

    // Handle changes in box number input text
    const onChangeBoxNumber = (boxNumberText) => {
        setBoxNumber(boxNumberText.target.value)
    }

    // Handle changes in date input for closing date
    const onChangeClosingDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate') {
            setClosingDateSelected(false)
        } else if (!selectedDate){
            setClosingDateSelected(false)
        } else {
            setClosingDate(selectedDate)
            setClosingDateSelected(true)
        }
    }

    // Handle when date is selected in date input for closing date
    const onAcceptClosingDate = (selectedDate) => {
        setClosingDate(selectedDate)
        setClosingDateSelected(true)
    }

    // Handle errors in date input for closing date
    const onErrorClosingDate = (error) => {
        if(error) {
            setClosingDateError(strings.invalidDate)
        } else {
            setClosingDateError(null)
        }
    }

    // Handle changes in amount input text
    const onChangeAmount = (amountText) => {
        setAmount(amountText.target.value)
        getGrossValue()
    }

    // Handle changes in unitary value input text
    const onChangeUnitaryValue = (unitaryValueText) => {
        setUnitaryValue(unitaryValueText.target.value)
        getGrossValue()
    }

    // Handle changes in iva dropdown input
    const onChangeIva = (item) => {
        setSelectedIva(item)
        getSubtotal()
    }

    // Handle the calculation of the gross value of consumption and power rate
    const getGrossValue = () => {
        if(amount.trim().length !== 0 && unitaryValue.trim().length !== 0) {

            return (amount * unitaryValue).toFixed(2)
        } else {
            return ''
        }
    }

    // Handle the calculation of the subtotal of consumption and power rate
    const getSubtotal = () => {
        if(amount.trim().length !== 0 && unitaryValue.trim().length !== 0 && getGrossValue().length !== 0 && selectedIva) {

            const decimalValue = parseFloat(selectedIva.label) / 100
            const ivaValue = getGrossValue() * decimalValue

            return (parseFloat(getGrossValue()) + ivaValue).toFixed(2)
        } else {
            return ''
        }
    }

    // Handle update energy values
    const updateEnergyValues = () => {
        setIsLoading(true)

        const data = {
            InitialReading: parseInt(initialReading),
            FinalReading: parseInt(finalReading),
            BoxNumber: parseInt(boxNumber),
            QuantityConsumed: parseInt(amount),
            EndDate: formatDate2(closingDate),
            UnitValue: parseInt(unitaryValue),
            GrossValue: parseInt(getGrossValue()),
            VAT: selectedIva.value,
            SubTotal: getSubtotal()
        }

        fetch(`/api/Schedule/${id}/UpdateEnergyValues`, {
            method:'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors',
            body: JSON.stringify(data)
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    setIsLoading(true)
                    getScheduleDetails()
                } else {
                    showErrorToast(strings.updateEnergyValuesError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })  
    }

    // Handle export reports
    const exportReport = () => {
        setIsLoading(true)

        fetch(`/api/Schedule/${id}/ExportToExcel`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const filename = `Relatório de agendamento.xlsx`
                    
                    const blob = await response.blob()
                    
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = filename
                    
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                } else if(response.status === 404) {
                    showErrorToast(strings.noSchedulesFoundError)
                } else {
                    showErrorToast(strings.exportToExcelError)
                }
                
            }, 1000)
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)
        })
    }

    // Check if all fields are not empty so the user can click 'Next' button
    const allFieldsValid = () => {
        if(initialReading.trim().length !== 0 && finalReading.trim().length !== 0 && boxNumber.trim().length !== 0 && closingDateSelected && amount.trim().length !== 0 && unitaryValue.trim().length !== 0  && selectedIva) {
            return true
        } else {
            return false
        }
    }

    // Check the harbor and show matching text
    const showHarborText = (harborId) => {
        const harbor = harbors && harbors.find((harbor) => harbor.id === harborId)
        return harbors && harbor.name
    }

    // Check the service type and show matching text
    const showServiceTypeText = (scheduleTypeId) => {
        const serviceType = services && services.find((service) => service.id === scheduleTypeId)
        return serviceType ? serviceType.name : strings.accessToFacilities
    }

    // Check the equipment and show matching text
    const showEquipmentText = (equipmentId) => {
        const equipment = equipments && equipments.find((equipment) => equipment.id === equipmentId)
        return equipment && equipment.name
    }

    // Handle the calculation of the number of days between start date and end date
    const getNumberOfDays = (startDate, endDate) => {
        const start = dayjs(startDate)
        const end = dayjs(endDate)

        let hours = end.diff(start, 'hours')
        const days = Math.floor(hours / 24)

        return days + 1
    }

    // Handle update equipment
    const updateEquipment = (equipmentId) => {
        setIsLoading(true)

        const data = {
            EquipmentId: equipmentId
        }

        fetch(`/api/Schedule/${id}/UpdateEquipment`, {
            method:'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors',
            body: JSON.stringify(data)
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    setIsLoading(true)
                    getScheduleDetails()
                } else {
                    showErrorToast(strings.updateEquipmentError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })  
    }

    // Handle changes in travel lift checkbox
    const onChangeTravelLiftChecked = () => {
        setIsTravelLiftChecked(!isTravelLiftChecked)
        setIsAgriculturalTractor(false)
        setIsAutomobileCrane5T(false)
        setIsAutomobileCrane10T(false)

        if(!isTravelLiftChecked) {
            updateEquipment(Constants.EQUIPMENTS.travelLift)
        }
    }

    // Handle changes in agricultural tractor checkbox
    const onChangeAgriculturalTractorChecked = () => {
        setIsAgriculturalTractor(!isAgriculturalTractor)
        setIsTravelLiftChecked(false)
        setIsAutomobileCrane5T(false)
        setIsAutomobileCrane10T(false)

        if(!isAgriculturalTractor) {
            updateEquipment(Constants.EQUIPMENTS.agriculturalTractor)
        }
    }

    // Handle changes in automobile crane 5T checkbox
    const onChangeAutomobileCrane5TChecked = () => {
        setIsAutomobileCrane5T(!isAutomobileCrane5T)
        setIsAgriculturalTractor(false)
        setIsTravelLiftChecked(false)
        setIsAutomobileCrane10T(false)

        if(!isAutomobileCrane5T) {
            updateEquipment(Constants.EQUIPMENTS.automobileCrane5T)
        }
    }

    // Handle changes in automobile crane 10T checkbox
    const onChangeAutomobileCrane10TChecked = () => {
        setIsAutomobileCrane10T(!isAutomobileCrane10T)
        setIsAgriculturalTractor(false)
        setIsTravelLiftChecked(false)
        setIsAutomobileCrane5T(false)

        if(!isAutomobileCrane10T) {
            updateEquipment(Constants.EQUIPMENTS.automobileCrane10T)
        }
    }

    // Check if 2 dates are not equal
    const areDatesNotEqual = (date1, date2) => {
        const firstDate = new Date(date1)
        const secondDate = new Date(date2)

        return (
            firstDate.getFullYear() !== secondDate.getFullYear() 
            || firstDate.getMonth() !== secondDate.getMonth()
            || firstDate.getDate() !== secondDate.getDate()
        )
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }
 
    return (
        <>
            <TopNavBar />

            { isLoading ?
                <div className='h-screen'>
                    <LoadingModal />
                </div>
            :   <div className='px-[12.5rem] min-h-screen mb-6'>  
                    <div className='flex items-center justify-between mt-12 mb-[3.375rem]'>

                        <div className='flex flex-row items-center space-x-2'>
                            <button onClick={() => navigate(-1)}>
                                <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                            </button>
                            <p className='font-montserrat font-semibold text-accent'>{strings.seeSchedule}</p>
                        </div>
                        
                            <div className='flex flex-row items-center space-x-6'>
                                { isPastSchedule ? 
                                    loggedUser && loggedUser.role !== Constants.Roles.CLIENT ?
                                        <>
                                            <div className='flex w-48'>
                                                <RoundedBorderButton
                                                    text={strings.exportReport}
                                                    onClick={exportReport}
                                                    height={40}
                                                    fontWeight='600'
                                                />
                                            </div>

                                            { loggedUser.role === Constants.Roles.ADMINIT ?
                                                <div className='flex w-56'>
                                                    <RoundedButton 
                                                        onClick={cancelSchedule}
                                                        text={strings.deleteSchedule}
                                                        height={40}
                                                        bgColor='#E85F5C'
                                                    />
                                                </div>
                                            : null }
                                        </>
                                    : null 
                                :   loggedUser && loggedUser.role !== Constants.Roles.CLIENT ?
                                        <>
                                            { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? 
                                                <div className='flex w-48'>
                                                    <RoundedBorderButton
                                                        text={strings.exportReport}
                                                        onClick={exportReport}
                                                        height={40}
                                                        fontWeight='600'
                                                    />
                                                </div>
                                            :   schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE ?
                                                    <>    
                                                        <div className='flex w-48'>
                                                            <RoundedBorderButton
                                                                text={strings.exportReport}
                                                                onClick={exportReport}
                                                                height={40}
                                                                fontWeight='600'
                                                            />
                                                        </div>

                                                        {schedule && docapescaId && schedule.entityId === docapescaId ?
                                                            <div className='flex w-56'>
                                                                <RoundedButton 
                                                                    onClick={cancelSchedule}
                                                                    text={strings.cancelSchedule}
                                                                    height={40}
                                                                    bgColor='#E85F5C'
                                                                />
                                                            </div>
                                                        :   loggedUser.role === Constants.Roles.ADMINIT || loggedUser.role === Constants.Roles.DEALER ?
                                                                <div className='flex w-56'>
                                                                    <RoundedButton 
                                                                        onClick={cancelSchedule}
                                                                        text={strings.cancelSchedule}
                                                                        height={40}
                                                                        bgColor='#E85F5C'
                                                                    />
                                                                </div>
                                                            : null
                                                        }
                                                        
                                                    </>
                                                :   <>    
                                                        <div className='flex w-48'>
                                                            <RoundedBorderButton
                                                                text={strings.exportReport}
                                                                onClick={exportReport}
                                                                height={40}
                                                                fontWeight='600'
                                                            />
                                                        </div>

                                                        {schedule && docapescaId && schedule.entityId === docapescaId ?
                                                            <>
                                                                <div className='flex w-40'>
                                                                    <RoundedButton 
                                                                        onClick={() => navigate(`/suggest-schedule/${id}`)}
                                                                        text={strings.suggest}
                                                                        height={40}
                                                                        bgColor='#007EB4'
                                                                    />
                                                                </div>

                                                                <div className='flex w-40'>
                                                                    <RoundedButton 
                                                                        onClick={rejectSuggestion}
                                                                        text={strings.reject}
                                                                        height={40}
                                                                        bgColor='#E85F5C'
                                                                    />
                                                                </div>

                                                                <div className='flex w-40'>
                                                                    <RoundedButton 
                                                                        onClick={acceptSuggestion}
                                                                        text={strings.accept}
                                                                        height={40}
                                                                        bgColor='#26AB93'
                                                                    />
                                                                </div>
                                                            </>
                                                        :   loggedUser.role === Constants.Roles.ADMINIT || loggedUser.role === Constants.Roles.DEALER ?
                                                                <>
                                                                    <div className='flex w-40'>
                                                                        <RoundedButton 
                                                                            onClick={() => navigate(`/suggest-schedule/${id}`)}
                                                                            text={strings.suggest}
                                                                            height={40}
                                                                            bgColor='#007EB4'
                                                                        />
                                                                    </div>

                                                                    <div className='flex w-40'>
                                                                        <RoundedButton 
                                                                            onClick={rejectSuggestion}
                                                                            text={strings.reject}
                                                                            height={40}
                                                                            bgColor='#E85F5C'
                                                                        />
                                                                    </div>

                                                                    <div className='flex w-40'>
                                                                        <RoundedButton 
                                                                            onClick={acceptSuggestion}
                                                                            text={strings.accept}
                                                                            height={40}
                                                                            bgColor='#26AB93'
                                                                        />
                                                                    </div>
                                                                </>
                                                            : null
                                                        }
                                                        
                                                    </>
                                            }
                                        </>
                                        
                                    :   <div className='flex flex-row space-x-6'>
                                            <div className='flex w-56'>
                                                <RoundedButton 
                                                    onClick={schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE ? rejectSuggestion : schedule.scheduleStatusId === Constants.ScheduleStatus.REJECTED ? discardSchedule : onClickCancel)}
                                                    text={schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE ? strings.rejectSuggestion : schedule.scheduleStatusId === Constants.ScheduleStatus.REJECTED ? strings.discard : strings.cancelSchedule)}
                                                    height={40}
                                                    bgColor='#E85F5C'
                                                />
                                            </div>

                                            { schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE || schedule.scheduleStatusId === Constants.ScheduleStatus.REJECTED) ?
                                                <div className='flex w-56'>
                                                    <RoundedButton 
                                                        onClick={schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE ? acceptSuggestion : reschedule)}
                                                        text={schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE ? strings.acceptSuggestion : strings.reschedule2)}
                                                        height={40}
                                                        bgColor='#26AB93'
                                                    />
                                                </div>
                                            : null }
                                        </div>   
                                }
                            </div>
                    </div>

                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.reason ?
                        <>
                            <SectionHeaderView 
                                text={strings.justificationSchedulingSuggestion}
                                margin={24}
                            />

                            <p className='font-montserrat text-xl font-semibold mb-12 px-4'>{schedule && schedule.reason}</p>
                        </>
                    : null }
                    
                    <SectionHeaderView 
                        text={strings.info}
                        margin={24}
                    />

                    <div className='flex flex-row px-4 mb-6 space-x-2'>
                        <div className='flex flex-col w-1/4'>
                            <p className='font-montserrat text-sm'>{strings.boatToIntervene}</p>
                            <p className='font-montserrat text-xl font-semibold'>{boat && boat.name}</p>
                        </div>
                        <div className='flex flex-col w-1/4'>
                            <p className='font-montserrat text-sm'>{strings.interventionLocal}</p>
                            <p className='font-montserrat text-xl font-semibold'>{schedule && showHarborText(schedule.harborId)}</p>
                        </div>
                        <div className='flex flex-col w-1/4'>
                            <p className='font-montserrat text-sm'>{strings.interventionType}</p>
                            <p className='font-montserrat text-xl font-semibold'>{schedule && showServiceTypeText(schedule.scheduleTypeId)}</p>
                        </div>
                        { schedule && schedule.scheduleTypeId === Constants.ScheduleTypes.ENERGY ? null
                        :   <div className='flex flex-col w-1/4'>
                                <p className='font-montserrat text-sm'>{strings.electricitySupply}</p>
                                <p className='font-montserrat text-xl font-semibold'>{schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY ? strings.yes : strings.no)}</p>
                            </div>
                        }
                    </div>

                    { loggedUser && loggedUser.role !== Constants.Roles.CLIENT ? 
                        <div className='flex flex-row px-4 mb-8 space-x-0.5'>
                            <div className='flex flex-col w-1/4'>
                                <p className='font-montserrat text-sm'>{strings.registration}</p>
                                <p className='font-montserrat text-xl font-semibold'>{boat && boat.registration}</p>
                            </div>
                            <div className='flex flex-col w-1/4'>
                                <p className='font-montserrat text-sm'>{strings.grossTonnage}</p>
                                <p className='font-montserrat text-xl font-semibold'>{boat && boat.grossTonnage + strings.grt}</p>
                            </div>
                            <div className='flex flex-col w-1/4'>
                                <p className='font-montserrat text-sm'>{strings.outOutLength}</p>
                                <p className='font-montserrat text-xl font-semibold'>{boat && boat.length + strings.m}</p>
                            </div>
                        </div>
                    : null }

                    { schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.MOORING || schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY) ? 
                        <>
                            <SectionHeaderView 
                                text={strings.mooring}
                                margin={24}
                            />

                            <div className='flex flex-row px-4 mt-4 mb-8'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.startDate}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && areDatesNotEqual(schedule.pastScheduling.startDate, schedule.startDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.startDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && areDatesNotEqual(schedule.pastScheduling.startDate, schedule.startDate)) ? 
                                                formatDate(schedule.pastScheduling.startDate) 
                                            :   formatDate(schedule.startDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && areDatesNotEqual(schedule.pastScheduling.startDate, schedule.startDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.startDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.endDate}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.endDate && areDatesNotEqual(schedule.pastScheduling.endDate, schedule.endDate))  ? 'line-through' : null }}>
                                        { schedule && schedule.endDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.endDate && areDatesNotEqual(schedule.pastScheduling.endDate, schedule.endDate)) ? 
                                                formatDate(schedule.pastScheduling.endDate) 
                                            :   formatDate(schedule.endDate) : '-' }
                                    </p>
                                    {schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.endDate && areDatesNotEqual(schedule.pastScheduling.endDate, schedule.endDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.endDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.numberOfDays}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.endDate && (schedule.pastScheduling.startDate !== schedule.startDate || schedule.pastScheduling.endDate !== schedule.endDate) && (getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate) !== getNumberOfDays(schedule.startDate, schedule.endDate))) ? 'line-through' : null }}>
                                        { schedule && schedule.startDate && schedule.endDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.endDate && (schedule.pastScheduling.startDate !== schedule.startDate || schedule.pastScheduling.endDate !== schedule.endDate) && (getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate) !== getNumberOfDays(schedule.startDate, schedule.endDate))) ? 
                                                getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate)
                                            :   getNumberOfDays(schedule.startDate, schedule.endDate) : '-' }
                                    </p>
                                    {schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.endDate && (schedule.pastScheduling.startDate !== schedule.startDate || schedule.pastScheduling.endDate !== schedule.endDate) && (getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate) !== getNumberOfDays(schedule.startDate, schedule.endDate)) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{getNumberOfDays(schedule.startDate, schedule.endDate)}</p>
                                    : null }
                                </div>
                            </div>
                        </>
                    : null }

                    { schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRING || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY) ? 
                        <>
                            <SectionHeaderView 
                                text={strings.fairing}
                                margin={24}
                            />

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4 mt-8'>{strings.stay}</p>

                            <div className='flex flex-row px-4 mt-4 space-x-4'>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.startDate}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.startDate !== schedule.startDate) ? 'line-through' : null }}>
                                        { schedule && schedule.startDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.startDate !== schedule.startDate) ?
                                                formatDate(schedule.pastScheduling.startDate)
                                            :   formatDate(schedule.startDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.startDate !== schedule.startDate ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.startDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.endDate}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.endDate && schedule.pastScheduling.endDate !== schedule.endDate) ? 'line-through' : null }}>
                                        { schedule && schedule.endDate ? (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.endDate && schedule.pastScheduling.endDate !== schedule.endDate) ?
                                            formatDate(schedule.pastScheduling.endDate)
                                        :   formatDate(schedule.endDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.endDate && schedule.pastScheduling.endDate !== schedule.endDate ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.endDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.numberOfDays}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.endDate  && (schedule.pastScheduling.startDate !== schedule.startDate || schedule.pastScheduling.endDate !== schedule.endDate) && (getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate) !== getNumberOfDays(schedule.startDate, schedule.endDate))) ? 'line-through' : null }}>
                                        { schedule && schedule.startDate && schedule.endDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.endDate  && (schedule.pastScheduling.startDate !== schedule.startDate || schedule.pastScheduling.endDate !== schedule.endDate) && (getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate) !== getNumberOfDays(schedule.startDate, schedule.endDate))) ?
                                                getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate)
                                            :   getNumberOfDays(schedule.startDate, schedule.endDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.startDate && schedule.pastScheduling.endDate  && (schedule.pastScheduling.startDate !== schedule.startDate || schedule.pastScheduling.endDate !== schedule.endDate) && (getNumberOfDays(schedule.pastScheduling.startDate, schedule.pastScheduling.endDate) !== getNumberOfDays(schedule.startDate, schedule.endDate)) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{getNumberOfDays(schedule.startDate, schedule.endDate)}</p>
                                    : null }
                                </div>
                            </div>

                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.putToDry}</p>

                            <div className='flex flex-row px-4 mt-4 space-x-2'>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.date}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.dryStartDate && schedule.pastScheduling.dryStartDate !== schedule.dryStartDate && formatDate(schedule.pastScheduling.dryStartDate) !== formatDate(schedule.dryStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.dryStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.dryStartDate && schedule.pastScheduling.dryStartDate !== schedule.dryStartDate && formatDate(schedule.pastScheduling.dryStartDate) !== formatDate(schedule.dryStartDate)) ?
                                                formatDate(schedule.pastScheduling.dryStartDate)
                                            :   formatDate(schedule.dryStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.dryStartDate && schedule.pastScheduling.dryStartDate !== schedule.dryStartDate && formatDate(schedule.pastScheduling.dryStartDate) !== formatDate(schedule.dryStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.dryStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.startTime}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.dryStartDate && schedule.pastScheduling.dryStartDate !== schedule.dryStartDate && formatTime(schedule.pastScheduling.dryStartDate) !== formatTime(schedule.dryStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.dryStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.dryStartDate && schedule.pastScheduling.dryStartDate !== schedule.dryStartDate && formatTime(schedule.pastScheduling.dryStartDate) !== formatTime(schedule.dryStartDate)) ?
                                                formatTime(schedule.pastScheduling.dryStartDate)
                                            :   formatTime(schedule.dryStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.dryStartDate && schedule.pastScheduling.dryStartDate !== schedule.dryStartDate && formatTime(schedule.pastScheduling.dryStartDate) !== formatTime(schedule.dryStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatTime(schedule.dryStartDate)}</p>
                                    : null }
                                </div>
                            </div>

                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.putToSwim}</p>

                            <div className='flex flex-row px-4 mt-4 space-x-2'>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.date}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.swimStartDate && schedule.pastScheduling.swimStartDate !== schedule.swimStartDate && formatDate(schedule.pastScheduling.swimStartDate) !== formatDate(schedule.swimStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.swimStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.swimStartDate && schedule.pastScheduling.swimStartDate !== schedule.swimStartDate && formatDate(schedule.pastScheduling.swimStartDate) !== formatDate(schedule.swimStartDate)) ?
                                                formatDate(schedule.pastScheduling.swimStartDate) 
                                            :   formatDate(schedule.swimStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.swimStartDate && schedule.pastScheduling.swimStartDate !== schedule.swimStartDate && formatDate(schedule.pastScheduling.swimStartDate) !== formatDate(schedule.swimStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.swimStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.startTime}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.swimStartDate && schedule.pastScheduling.swimStartDate !== schedule.swimStartDate && formatTime(schedule.pastScheduling.swimStartDate) !== formatTime(schedule.swimStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.swimStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.swimStartDate && schedule.pastScheduling.swimStartDate !== schedule.swimStartDate && formatTime(schedule.pastScheduling.swimStartDate) !== formatTime(schedule.swimStartDate)) ?
                                                formatTime(schedule.pastScheduling.swimStartDate)
                                            :   formatTime(schedule.swimStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.swimStartDate && schedule.pastScheduling.swimStartDate !== schedule.swimStartDate && formatTime(schedule.pastScheduling.swimStartDate) !== formatTime(schedule.swimStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatTime(schedule.swimStartDate)}</p>
                                    : null }
                                </div>
                            </div>

                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.lineChange}</p>

                            <div className='flex flex-row px-4 mt-4 space-x-2'>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.date}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.lineChangeStartDate && schedule.pastScheduling.lineChangeStartDate !== schedule.lineChangeStartDate && formatDate(schedule.pastScheduling.lineChangeStartDate) !== formatDate(schedule.lineChangeStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.lineChangeStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.lineChangeStartDate && schedule.pastScheduling.lineChangeStartDate !== schedule.lineChangeStartDate && formatDate(schedule.pastScheduling.lineChangeStartDate) !== formatDate(schedule.lineChangeStartDate)) ?
                                                formatDate(schedule.pastScheduling.lineChangeStartDate)
                                            :   formatDate(schedule.lineChangeStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.lineChangeStartDate && schedule.pastScheduling.lineChangeStartDate !== schedule.lineChangeStartDate && formatDate(schedule.pastScheduling.lineChangeStartDate) !== formatDate(schedule.lineChangeStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.lineChangeStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.startTime}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.lineChangeStartDate && schedule.pastScheduling.lineChangeStartDate !== schedule.lineChangeStartDate && formatTime(schedule.pastScheduling.lineChangeStartDate) !== formatTime(schedule.lineChangeStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.lineChangeStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.lineChangeStartDate && schedule.pastScheduling.lineChangeStartDate !== schedule.lineChangeStartDate && formatTime(schedule.pastScheduling.lineChangeStartDate) !== formatTime(schedule.lineChangeStartDate)) ?
                                                formatTime(schedule.pastScheduling.lineChangeStartDate)
                                            :   formatTime(schedule.lineChangeStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.lineChangeStartDate && schedule.pastScheduling.lineChangeStartDate !== schedule.lineChangeStartDate && formatTime(schedule.pastScheduling.lineChangeStartDate) !== formatTime(schedule.lineChangeStartDate)?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatTime(schedule.lineChangeStartDate)}</p>
                                    : null }
                                </div>
                            </div>

                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.supplyPersonnel}</p>

                            <div className='flex flex-row px-4 mt-4 space-x-2'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.date}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelStartDate && schedule.pastScheduling.supplyPersonnelStartDate !== schedule.supplyPersonnelStartDate && formatDate(schedule.pastScheduling.supplyPersonnelStartDate) !== formatDate(schedule.supplyPersonnelStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.supplyPersonnelStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelStartDate && schedule.pastScheduling.supplyPersonnelStartDate !== schedule.supplyPersonnelStartDate && formatDate(schedule.pastScheduling.supplyPersonnelStartDate) !== formatDate(schedule.supplyPersonnelStartDate)) ?
                                                formatDate(schedule.pastScheduling.supplyPersonnelStartDate)
                                            :   formatDate(schedule.supplyPersonnelStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelStartDate && schedule.pastScheduling.supplyPersonnelStartDate !== schedule.supplyPersonnelStartDate && formatDate(schedule.pastScheduling.supplyPersonnelStartDate) !== formatDate(schedule.supplyPersonnelStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.supplyPersonnelStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.startTime}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelStartDate && schedule.pastScheduling.supplyPersonnelStartDate !== schedule.supplyPersonnelStartDate && formatTime(schedule.pastScheduling.supplyPersonnelStartDate) !== formatTime(schedule.supplyPersonnelStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.supplyPersonnelStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelStartDate && schedule.pastScheduling.supplyPersonnelStartDate !== schedule.supplyPersonnelStartDate && formatTime(schedule.pastScheduling.supplyPersonnelStartDate) !== formatTime(schedule.supplyPersonnelStartDate)) ?
                                                formatTime(schedule.pastScheduling.supplyPersonnelStartDate)
                                            :   formatTime(schedule.supplyPersonnelStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelStartDate && schedule.pastScheduling.supplyPersonnelStartDate !== schedule.supplyPersonnelStartDate && formatTime(schedule.pastScheduling.supplyPersonnelStartDate) !== formatTime(schedule.supplyPersonnelStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatTime(schedule.supplyPersonnelStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.endTime}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelEndDate && schedule.pastScheduling.supplyPersonnelEndDate !== schedule.supplyPersonnelEndDate && formatTime(schedule.pastScheduling.supplyPersonnelEndDate) !== formatTime(schedule.supplyPersonnelEndDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.supplyPersonnelEndDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelEndDate && schedule.pastScheduling.supplyPersonnelEndDate !== schedule.supplyPersonnelEndDate && formatTime(schedule.pastScheduling.supplyPersonnelEndDate) !== formatTime(schedule.supplyPersonnelEndDate)) ?
                                                formatTime(schedule.pastScheduling.supplyPersonnelEndDate)
                                            :   formatTime(schedule.supplyPersonnelEndDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnelEndDate && schedule.pastScheduling.supplyPersonnelEndDate !== schedule.supplyPersonnelEndDate && formatTime(schedule.pastScheduling.supplyPersonnelEndDate) !== formatTime(schedule.supplyPersonnelEndDate)?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatTime(schedule.supplyPersonnelEndDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.numberOfMen}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnel && schedule.pastScheduling.supplyPersonnel !== schedule.supplyPersonnel) ? 'line-through' : null }}>
                                        { schedule && schedule.supplyPersonnel ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnel && schedule.pastScheduling.supplyPersonnel !== schedule.supplyPersonnel)  ?
                                                schedule.pastScheduling.supplyPersonnel
                                            :   schedule.supplyPersonnel : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.supplyPersonnel && schedule.pastScheduling.supplyPersonnel !== schedule.supplyPersonnel ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{schedule.supplyPersonnel}</p>
                                    : null }
                                </div>
                            </div>

                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.ripping}</p>

                            <div className='flex flex-col px-4 mt-4'>
                                <p className='font-montserrat text-sm'>{strings.serviceDescription}</p>
                                <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingDescription && schedule.pastScheduling.rippingDescription !== schedule.rippingDescription) ? 'line-through' : null }}>
                                    { schedule && schedule.rippingDescription ? 
                                        (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingDescription && schedule.pastScheduling.rippingDescription !== schedule.rippingDescription) ?
                                            schedule.pastScheduling.rippingDescription
                                        :   schedule.rippingDescription : '-' }
                                </p>
                                { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingDescription && schedule.pastScheduling.rippingDescription !== schedule.rippingDescription ?
                                    <p className='font-montserrat text-xl font-semibold text-negative'>{schedule.rippingDescription}</p>
                                : null }
                            </div>

                            <div className='flex flex-row px-4 mt-4 mb-8 space-x-2'>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.date}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingStartDate && schedule.pastScheduling.rippingStartDate !== schedule.rippingStartDate && formatDate(schedule.pastScheduling.rippingStartDate) !== formatDate(schedule.rippingStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.rippingStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingStartDate && schedule.pastScheduling.rippingStartDate !== schedule.rippingStartDate && formatDate(schedule.pastScheduling.rippingStartDate) !== formatDate(schedule.rippingStartDate)) ?
                                                formatDate(schedule.pastScheduling.rippingStartDate)
                                            :   formatDate(schedule.rippingStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingStartDate && schedule.pastScheduling.rippingStartDate !== schedule.rippingStartDate && formatDate(schedule.pastScheduling.rippingStartDate) !== formatDate(schedule.rippingStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.rippingStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.startTime}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingStartDate && schedule.pastScheduling.rippingStartDate !== schedule.rippingStartDate && formatTime(schedule.pastScheduling.rippingStartDate) !== formatTime(schedule.rippingStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.rippingStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingStartDate && schedule.pastScheduling.rippingStartDate !== schedule.rippingStartDate && formatTime(schedule.pastScheduling.rippingStartDate) !== formatTime(schedule.rippingStartDate)) ?
                                                formatTime(schedule.pastScheduling.rippingStartDate)
                                            :   formatTime(schedule.rippingStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingStartDate && schedule.pastScheduling.rippingStartDate !== schedule.rippingStartDate && formatTime(schedule.pastScheduling.rippingStartDate) !== formatTime(schedule.rippingStartDate)?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatTime(schedule.rippingStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/3'>
                                    <p className='font-montserrat text-sm'>{strings.endTime}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingEndDate && schedule.pastScheduling.rippingEndDate !== schedule.rippingEndDate && formatTime(schedule.pastScheduling.rippingEndDate) !== formatTime(schedule.rippingEndDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.rippingEndDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingEndDate && schedule.pastScheduling.rippingEndDate !== schedule.rippingEndDate) && formatTime(schedule.pastScheduling.rippingEndDate) !== formatTime(schedule.rippingEndDate) ?
                                                formatTime(schedule.pastScheduling.rippingEndDate)
                                            :   formatTime(schedule.rippingEndDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.rippingEndDate && schedule.pastScheduling.rippingEndDate !== schedule.rippingEndDate && formatTime(schedule.pastScheduling.rippingEndDate) !== formatTime(schedule.rippingEndDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatTime(schedule.rippingEndDate)}</p>
                                    : null }
                                </div>
                            </div>

                            { loggedUser && loggedUser.role === Constants.Roles.PORTTECHNICIAN && schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED && schedule.equipmentId === 0 ?
                                <>
                                    <div className='h-px bg-neutral3 my-8'/>

                                    <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.equipments}</p>

                                    <div className='flex flex-1 flex-row mt-[1.125rem] ps-4 space-x-20 mb-8'>
                                        <div className='flex flex-row items-center'>
                                            <input id='travelLift' type='checkbox' checked={isTravelLiftChecked} onChange={onChangeTravelLiftChecked} className='me-3 h-6 w-6 accent-accent cursor-pointer'/>
                                            <label htmlFor='travelLift' className='font-montserrat cursor-pointer'>{strings.travelLift}</label>
                                        </div>

                                        <div className='flex flex-row items-center'>
                                            <input id='agriculturalTractor' type='checkbox' checked={isAgriculturalTractor} onChange={onChangeAgriculturalTractorChecked} className='me-3 h-6 w-6 accent-accent cursor-pointer'/>
                                            <label htmlFor='agriculturalTractor' className='font-montserrat cursor-pointer'>{strings.agriculturalTractor}</label>
                                        </div>

                                        <div className='flex flex-row items-center'>
                                            <input id='automobileCrane5T' type='checkbox' checked={isAutomobileCrane5T} onChange={onChangeAutomobileCrane5TChecked} className='me-3 h-6 w-6 accent-accent cursor-pointer'/>
                                            <label htmlFor='automobileCrane5T' className='font-montserrat cursor-pointer'>{strings.automobileCrane5T}</label>
                                        </div>

                                        <div className='flex flex-row items-center'>
                                            <input id='automobileCrane10T' type='checkbox' checked={isAutomobileCrane10T} onChange={onChangeAutomobileCrane10TChecked} className='me-3 h-6 w-6 accent-accent cursor-pointer'/>
                                            <label htmlFor='automobileCrane10T' className='font-montserrat cursor-pointer'>{strings.automobileCrane10T}</label>
                                        </div>
                                    </div>
                                </>
                            : null }

                            { schedule && schedule.equipmentId !== 0 ?
                                <div>
                                    <div className='h-px bg-neutral3 my-8'/>

                                    <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.equipments2}</p>

                                    <div className='px-4 mt-4 mb-8'>
                                        <p className='font-montserrat text-sm'>{strings.equipmentType}</p>
                                        <p className='font-montserrat text-xl font-semibold'>
                                            {schedule && showEquipmentText(schedule.equipmentId)}
                                        </p>
                                    </div>
                                </div>
                            : null }
                        </>
                    : null}

                    { schedule && schedule.scheduleTypeId === Constants.ScheduleTypes.FACILITIES ? 
                        <>
                            <SectionHeaderView 
                                text={strings.accessToFacilities}
                                margin={24}
                            />

                            <div className='flex flex-row px-4 mt-4 mb-8'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.dateStartTime}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && formatDate3(schedule.accessFacilitiesStartDate)}
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.numberOfMen}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.accessFacilitiesNumberMen}
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/2'>
                                    <p className='font-montserrat text-sm'>{strings.workDescription}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.accessFacilitiesDescription}
                                    </p>
                                </div>
                            </div>
                        </>
                    : null }

                    { schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.ENERGY) ? 
                        <>
                            <SectionHeaderView 
                                text={strings.electricitySupply}
                                margin={24}
                            />

                            <div className='flex flex-row px-4 mb-8'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.date}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.powerStartDate && areDatesNotEqual(schedule.pastScheduling.powerStartDate, schedule.powerStartDate)) ? 'line-through' : null }}>
                                        { schedule && schedule.powerStartDate ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.powerStartDate && areDatesNotEqual(schedule.pastScheduling.powerStartDate, schedule.powerStartDate))  ?
                                                formatDate(schedule.pastScheduling.powerStartDate)
                                            :   formatDate(schedule.powerStartDate) : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.powerStartDate && areDatesNotEqual(schedule.pastScheduling.powerStartDate, schedule.powerStartDate) ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{formatDate(schedule.powerStartDate)}</p>
                                    : null }
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.contractedPower}</p>
                                    <p className='font-montserrat text-xl font-semibold' style={{ textDecoration: schedule && (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.power && schedule.pastScheduling.power !== schedule.power) ? 'line-through' : null }}>
                                        { schedule && schedule.power ? 
                                            (schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.power && schedule.pastScheduling.power !== schedule.power) ?
                                                schedule.pastScheduling.power
                                            :   schedule.power : '-' }
                                    </p>
                                    { schedule && schedule.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE && schedule.pastScheduling && schedule.pastScheduling.power && schedule.pastScheduling.power !== schedule.power ?
                                        <p className='font-montserrat text-xl font-semibold text-negative'>{schedule.power}</p>
                                    : null }
                                </div>
                            </div>
                        </>
                    : null }

                    { loggedUser && (loggedUser.role === Constants.Roles.PORTTECHNICIAN && (schedule && !schedule.powerInitialReading && (schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.ENERGY) && schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED)) ?
                        <>
                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.readings}</p>

                            <div className='flex flex-row mt-4 px-4 space-x-6'>
                                <div className='flex flex-col w-1/2'>
                                    <label htmlFor='initialReading' className='font-montserrat text-sm font-semibold mb-1.5'>{strings.initialReading}</label>
                                    <FormInput2
                                        id='initialReading' 
                                        type='text'
                                        value={initialReading}
                                        placeholder={strings.insertInitialReading}
                                        onChange={onChangeInitialReading}
                                        text={strings.kw}
                                    />
                                </div>

                                <div className='flex flex-col w-1/2'>
                                    <label htmlFor='finalReading' className='font-montserrat text-sm font-semibold mb-1.5'>{strings.finalReading}</label>
                                    <FormInput2
                                        id='finalReading' 
                                        type='text'
                                        value={finalReading}
                                        placeholder={strings.insertFinalReading}
                                        onChange={onChangeFinalReading}
                                        text={strings.kw}
                                    />
                                </div>
                            </div>

                            <div className='flex flex-row mt-8 px-4 space-x-6'>
                                <div className='flex flex-col w-1/2'>
                                    <label htmlFor='boxNumber' className='font-montserrat text-sm font-semibold mb-1.5'>{strings.boxNumber}</label>
                                    <FormInput
                                        id='boxNumber' 
                                        type='text'
                                        value={boxNumber}
                                        placeholder={strings.insertBoxNumber}
                                        onChange={onChangeBoxNumber}
                                    />
                                </div>

                                <div className='flex flex-col w-1/2'>
                                    <p className='font-montserrat text-sm font-semibold mb-3'>{strings.closingDate}</p>
                                    <DatePickerInput2
                                        value={closingDate}
                                        onChange={onChangeClosingDate}
                                        onAccept={onAcceptClosingDate}
                                        onError={onErrorClosingDate}
                                    />
                                    <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{closingDateError ? closingDateError : ''}</p>
                                </div>

                            </div>

                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.consumptionAndPowerRate}</p>

                            <div className='flex flex-row mt-4 px-4 space-x-6'>
                                <div className='flex flex-col w-2/6'>
                                    <label htmlFor='amount' className='font-montserrat text-sm font-semibold mb-1.5'>{strings.amount}</label>
                                    <FormInput
                                        id='amount' 
                                        type='text'
                                        value={amount}
                                        placeholder={strings.insertAmount}
                                        onChange={onChangeAmount}
                                    />
                                </div>

                                <div className='flex flex-col w-2/6'>
                                    <label htmlFor='unitaryValue' className='font-montserrat text-sm font-semibold mb-1.5'>{strings.unitaryValue}</label>
                                    <FormInput2
                                        id='unitaryValue' 
                                        type='text'
                                        value={unitaryValue}
                                        placeholder={strings.insertUnitaryValue}
                                        onChange={onChangeUnitaryValue}
                                        text={strings.eur}
                                    />
                                </div>

                                <div className='flex flex-col w-2/6'>
                                    <label htmlFor='grossValue' className='font-montserrat text-sm font-semibold mb-3'>{strings.grossValue}</label>
                                    <div className='flex flex-row justify-between py-2 px-3 bg-anti-flash-white rounded h-10'>
                                        <p className='font-montserrat'>{getGrossValue()}</p>
                                        <p className='font-montserrat text-neutral5'>{strings.eur}</p>
                                    </div>
                                </div>

                            </div>

                            <div className='flex flex-row mt-8 px-4 space-x-6'>
                                <div className='flex flex-col w-1/2'>
                                    <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.iva}</p>
                                    <DropdownInput
                                        options={Constants.IVA}
                                        value={selectedIva}
                                        onChange={onChangeIva}
                                    />
                                </div>

                                <div className='flex flex-col w-1/2'>
                                    <p className='font-montserrat text-sm font-semibold mb-3'>{strings.subtotal}</p>
                                    <div className='flex flex-row justify-between py-2 px-3 bg-anti-flash-white rounded h-10'>
                                        <p className='font-montserrat'>{getSubtotal()}</p>
                                        <p className='font-montserrat text-neutral5'>{strings.eur}</p>
                                    </div>
                                </div>

                            </div>

                            <div className='flex mt-10 mb-16 mx-4 w-[12.813rem]'>
                                <RoundedButton
                                    onClick={updateEnergyValues}
                                    text={strings.saveChanges}
                                    height={40}
                                    bgColor='#007EB4'
                                    disabled={allFieldsValid() ? false : true}
                                />
                            </div>

                        </>
                    : null }

                    { loggedUser && (loggedUser.role !== Constants.Roles.CLIENT && (schedule && schedule.powerInitialReading && (schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.ENERGY))) ?
                        <>
                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.readings2}</p>

                            <div className='flex flex-row px-4 mb-8 mt-4'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.initialReading}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerInitialReading}
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.finalReading}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerFinalReading}
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.boxNumber}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerBoxNumber}
                                    </p>
                                </div>
                            </div>

                            <div className='flex flex-row px-4 mb-8 mt-4'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.startDate}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && formatDate(schedule.powerStartDate)}
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.closingDate}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && formatDate(schedule.powerEndDate)}
                                    </p>
                                </div>
                            </div>

                            <div className='h-px bg-neutral3 my-8'/>

                            <p className='font-montserrat text-sm font-semibold text-accent ps-4'>{strings.consumptionAndPowerRate2}</p>

                            <div className='flex flex-row px-4 mb-8 mt-4'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.amount}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerQuantityConsumed}
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.unitaryValue}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerUnitValue} {strings.eur}
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.grossValue}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerGrossValue} {strings.eur}
                                    </p>
                                </div>
                            </div>

                            <div className='flex flex-row px-4 mb-8 mt-4'>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.iva}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerVAT} %
                                    </p>
                                </div>
                                <div className='flex flex-col w-1/4'>
                                    <p className='font-montserrat text-sm'>{strings.subtotal}</p>
                                    <p className='font-montserrat text-xl font-semibold'>
                                        {schedule && schedule.powerSubTotal} {strings.eur}
                                    </p>
                                </div>
                            </div>
                        </>
                    : null }

                </div>
            }

            <div className='mb-20'></div>

            <TwoButtonsModal
                open={showCancelScheduleModal}
                onClose={() => setShowCancelScheduleModal(false)}
                title={strings.cancelSchedule2}
                message={strings.cancelScheduleMessage}
                buttonText1={strings.back}
                buttonText2={strings.cancelSchedule}
                onClick={cancelSchedule}
            />

            <ToastContainer />
        </>
    )
}

export default ScheduleDetails